import React, { useState, useEffect } from 'react';
import { MapPin, Navigation2 } from 'lucide-react';

export default function MapView({ destination, currentStatus }) {
  const [vanPosition, setVanPosition] = useState({ lat: 1.3521, lng: 103.8198 }); // Starting from SGH

  // Simulate van movement towards destination
  useEffect(() => {
    if (currentStatus === 'prayer' || currentStatus === 'active') {
      const interval = setInterval(() => {
        setVanPosition(prev => ({
          lat: prev.lat + (destination.coordinates.lat - prev.lat) * 0.05,
          lng: prev.lng + (destination.coordinates.lng - prev.lng) * 0.05
        }));
      }, 2000);

      return () => clearInterval(interval);
    }
  }, [currentStatus, destination]);

  return (
    <div className="relative w-full h-[400px] bg-muted/30 rounded-lg overflow-hidden border">
      {/* Mock map background */}
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600"><rect fill="%23f0f0f0" width="800" height="600"/><path stroke="%23d0d0d0" stroke-width="1" fill="none" d="M0,100 Q200,50 400,100 T800,100 M0,200 Q200,150 400,200 T800,200 M0,300 L800,300 M0,400 Q200,450 400,400 T800,400 M100,0 L100,600 M300,0 L300,600 M500,0 L500,600 M700,0 L700,600"/><text x="50" y="40" font-family="Arial" font-size="14" fill="%23666">Jalan Bahar</text><text x="250" y="280" font-family="Arial" font-size="14" fill="%23666">PIE</text><text x="450" y="180" font-family="Arial" font-size="14" fill="%23666">Jurong</text></svg>')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />

      {/* Animated path line */}
      <svg className="absolute inset-0 w-full h-full pointer-events-none">
        <defs>
          <marker id="arrowhead" markerWidth="10" markerHeight="10" refX="5" refY="3" orient="auto">
            <polygon points="0 0, 10 3, 0 6" fill="hsl(var(--accent))" />
          </marker>
        </defs>
        <path
          d="M150,350 Q300,250 450,200 T650,150"
          stroke="hsl(var(--accent))"
          strokeWidth="3"
          fill="none"
          strokeDasharray="5,5"
          markerEnd="url(#arrowhead)"
          className="animate-pulse"
        />
      </svg>

      {/* Van Icon (current location) */}
      <div 
        className="absolute transition-all duration-1000 ease-linear"
        style={{
          left: '35%',
          top: '55%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <div className="relative">
          <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center shadow-lg border-2 border-white animate-pulse-gentle">
            <Navigation2 className="h-6 w-6 text-primary-foreground" style={{ transform: 'rotate(45deg)' }} />
          </div>
          <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap">
            <div className="bg-primary text-primary-foreground px-3 py-1 rounded text-sm font-medium shadow-md">
              Hearse Vehicle
            </div>
          </div>
        </div>
      </div>

      {/* Destination marker */}
      <div 
        className="absolute"
        style={{
          left: '75%',
          top: '25%',
          transform: 'translate(-50%, -100%)'
        }}
      >
        <div className="relative">
          <MapPin className="h-10 w-10 text-destructive fill-current drop-shadow-lg" />
          <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap">
            <div className="bg-card border text-card-foreground px-3 py-1 rounded text-sm font-medium shadow-md">
              {destination.name}
            </div>
          </div>
        </div>
      </div>

      {/* Map legend */}
      <div className="absolute bottom-4 left-4 bg-card border rounded-lg p-3 shadow-lg">
        <div className="text-xs font-semibold mb-2">Map Legend</div>
        <div className="flex items-center gap-2 text-xs mb-1">
          <div className="w-3 h-3 bg-primary rounded-full"></div>
          <span>Current Location</span>
        </div>
        <div className="flex items-center gap-2 text-xs">
          <MapPin className="h-3 w-3 text-destructive fill-current" />
          <span>Destination</span>
        </div>
      </div>

      {/* Info box */}
      <div className="absolute top-4 left-4 bg-card border rounded-lg p-3 shadow-lg max-w-xs">
        <div className="text-sm font-semibold mb-1">En Route to Mosque</div>
        <div className="text-xs text-muted-foreground">
          <div>Current: Prayer/Solat</div>
          <div className="mt-1">Estimated arrival: 2:30 PM</div>
        </div>
      </div>
    </div>
  );
}
